import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-row__column-content table-row__first-column"
}
const _hoisted_2 = { class: "handle-dnd" }
const _hoisted_3 = {
  key: 0,
  class: "table-row__column-content table-row__type"
}
const _hoisted_4 = {
  key: 0,
  class: "general-table-row__ellipsis"
}
const _hoisted_5 = { class: "table-row__column-content" }
const _hoisted_6 = {
  key: 0,
  class: "table-row__column-content table-row__roles"
}
const _hoisted_7 = {
  key: 0,
  class: "table-row__column-content add-link-table-row__roles"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "table-row__column-content" }

import { ElCol, ElRow, ElFormItem, ElTooltip } from 'element-plus';
import { toRef, computed, ref } from 'vue';
import { Close } from '@element-plus/icons-vue';
import { useI18n } from 'vue-i18n';
import BurgerIcon from '@/components/icons/Burger.vue';
import UiInput from '@/components/Form/UiInput.vue';
import {
  Link,
  ManualFlags,
  MediaFileEnum,
  DocumentType,
  DocumentTypeEnum,
  Locale,
  LinksRolesEnum, LinkRole,
} from '@/types/manuals';
import UiSelect from '@/components/Form/UiSelect.vue';
import { getDefaultFlags, acceptVideo, acceptDocument, getFieldByType } from '@/router/Admin/builderManuals';
import FileUpload from '@/components/Form/FileUpload.vue';
import { UploadedPayloadType } from '@/utils/fileUploader';
import { resetAllInvalidFileUploadEl } from '@/utils/validationRules';
import RoleAdmin from '@/components/icons/RoleAdmin.vue';
import RoleTeacher from '@/components/icons/RoleTeacher.vue';
import RoleStudent from '@/components/icons/RoleStudent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralTableRow',
  props: {
    item: {},
    localeMedia: {},
    index: {},
    indexLang: {},
    drag: { type: Boolean },
    type: {},
    isHideSelect: { type: Boolean },
    maxLength: { default: 32 }
  },
  emits: ["inputFileLink", "inputTextButton", "delete", "changeFile", "changeFlag", "switchRoles"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const btnPlaceholderText = computed(() => {
  const { locales } = props.item;
  if (!locales.length) { return ''; }
  const filledLocale = locales.find((loc: Locale) => loc.caption);
  return filledLocale?.caption ? filledLocale.caption : '';
});

const emit = __emit;

const isFileLoading = ref<boolean>(false);
const uploadInput = ref<InstanceType<typeof FileUpload> | null>(null);
const item = toRef(props, 'item');

const isCommon = ref(Boolean(props.item.parent_id));
const defaultFlags = getDefaultFlags(t);
const flagLabel = computed(
  () => defaultFlags.find((flag) => flag.value === item.value.flag)?.label
);

const notSaved = computed<boolean>(() => !item.value.locales);
const isVideo = props.type === DocumentTypeEnum.Video;
const isLink = props.type === DocumentTypeEnum.Link;
const isVideoOrDoc = !isLink;
const fieldName = getFieldByType(props.type);
const acceptFile = isVideo ? acceptVideo : acceptDocument;

const buttonText = computed(() => props.localeMedia?.caption || '');
const itemUrl = computed(() => props.localeMedia?.file || '');
const isFile = computed(() => props.localeMedia?.file_type === MediaFileEnum.File);

const isInputFocused = ref<boolean>(false);

const isColored = computed(() => {
  if (!isLink) { return false; }
  return props.localeMedia?.filledLang === props.localeMedia.locale;
});

const rolesDefault = [{
  name: t('roles.admin'),
  value: LinksRolesEnum.Admin,
  icon: RoleAdmin,
  active: false,
},
{
  name: t('roles.teacher'),
  value: LinksRolesEnum.Teacher,
  icon: RoleTeacher,
  active: false,
},
{
  name: t('roles.student'),
  value: LinksRolesEnum.Student,
  icon: RoleStudent,
  active: false,
}];

const roles = computed(() => rolesDefault.map((role) => ({
  ...role,
  active: props.item.for_roles ? props.item.for_roles.includes(role.value) : false,
})));

const switchRole = (role: LinkRole) => {
  if (!props.item.for_roles) { return; }
  const innerRoles = [...props.item.for_roles];
  const index = innerRoles.indexOf(role);
  if (index !== -1) {
    innerRoles.splice(index, 1);
  } else {
    innerRoles.push(role);
  }

  emit('switchRoles', { index: props.index, value: innerRoles });
};

const handlerChangeFlag = (value: ManualFlags) => {
  emit('changeFlag', { index: props.index, value });
};
const handleLinkInput = (value: string) => {
  emit('inputFileLink', { index: props.index, value, needFillAnotherFields: isLink });
};

const handleTextButtonInput = (value: string) => {
  emit('inputTextButton', { index: props.index, value });
};

const fileLoading = (bool: boolean) => {
  hasError.value = false;
  resetAllInvalidFileUploadEl();
  isFileLoading.value = bool;
};

const changeFile = (data: UploadedPayloadType) => {
  hasError.value = false;
  emit('changeFile', { data, index: props.index, indexLang: props.indexLang });
};

const hasError = ref(false);
const catchError = () => {
  hasError.value = true;
};

const handleDelete = () => {
  emit('delete', props.index);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElRow), { class: "general-table-row table-row__row" }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElCol), {
        span: 1,
        class: "table-row__column"
      }, {
        default: _withCtx(() => [
          (!item.value.isDisabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["table-row__dnd-button", { 'use-hover': !_ctx.drag }])
                  }, [
                    _createVNode(BurgerIcon)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      isVideoOrDoc
        ? (_openBlock(), _createBlock(_unref(ElCol), {
            key: 0,
            span: 2,
            class: "table-row__column"
          }, {
            default: _withCtx(() => [
              (!item.value.isDisabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (isCommon.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(flagLabel.value), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(isFile.value ? _unref(t)('labelFile') : _unref(t)('fields.url')), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(ElCol), {
        span: _ctx.isHideSelect ? 13 : 9,
        class: "table-row__column"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ElFormItem), {
              prop: `${_unref(fieldName)}.${_ctx.index}.locales.${_ctx.indexLang}.file`
            }, {
              default: _withCtx(() => [
                (isFile.value)
                  ? (_openBlock(), _createBlock(FileUpload, {
                      key: 0,
                      ref_key: "uploadInput",
                      ref: uploadInput,
                      accept: _unref(acceptFile),
                      class: "fullwidth",
                      url: itemUrl.value,
                      error: hasError.value,
                      disabledCopy: notSaved.value || !itemUrl.value,
                      disabled: isCommon.value,
                      "data-el-name": `${_unref(fieldName)}.${_ctx.index}.locales.${_ctx.indexLang}.file`,
                      onFileLoading: fileLoading,
                      onFileUpdate: changeFile,
                      onHasError: catchError
                    }, null, 8, ["accept", "url", "error", "disabledCopy", "disabled", "data-el-name"]))
                  : (_openBlock(), _createBlock(UiInput, {
                      key: 1,
                      value: itemUrl.value,
                      class: _normalizeClass(["upload-file__input", { 'table-row__row-blue': isColored.value }]),
                      copy: "",
                      disabled: item.value.isDisabled || isCommon.value,
                      "data-el-name": `${_unref(fieldName)}.${_ctx.index}.locales.${_ctx.indexLang}.file`,
                      onInput: handleLinkInput
                    }, null, 8, ["value", "class", "disabled", "data-el-name"]))
              ]),
              _: 1
            }, 8, ["prop"])
          ])
        ]),
        _: 1
      }, 8, ["span"]),
      (isVideoOrDoc && !_ctx.isHideSelect)
        ? (_openBlock(), _createBlock(_unref(ElCol), {
            key: 1,
            span: 4,
            class: "table-row__column"
          }, {
            default: _withCtx(() => [
              (!item.value.isDisabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(ElFormItem), {
                      prop: `${_unref(fieldName)}.${_ctx.index}.flag`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(UiSelect, {
                          value: item.value.flag,
                          options: _unref(defaultFlags),
                          "data-el-name": `${_unref(fieldName)}.${_ctx.index}.flag`,
                          onChange: handlerChangeFlag
                        }, null, 8, ["value", "options", "data-el-name"])
                      ]),
                      _: 1
                    }, 8, ["prop"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      isLink
        ? (_openBlock(), _createBlock(_unref(ElCol), {
            key: 2,
            span: 3,
            class: "table-row__column"
          }, {
            default: _withCtx(() => [
              (!item.value.isDisabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, ({ name, value, icon, active }) => {
                      return (_openBlock(), _createBlock(_unref(ElTooltip), {
                        key: value,
                        content: name,
                        enterable: false,
                        placement: "bottom",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["add-link-table-row__role", { active }]),
                            onClick: ($event: any) => (switchRole(value))
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(icon)))
                          ], 10, _hoisted_8)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(ElCol), {
        span: isVideoOrDoc ? 8 : 7,
        class: "table-row__column"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(ElFormItem), {
              prop: `${_unref(fieldName)}.${_ctx.index}.locales.${_ctx.indexLang}.caption`
            }, {
              default: _withCtx(() => [
                _createVNode(UiInput, {
                  disabled: item.value.isDisabled || isCommon.value,
                  value: buttonText.value,
                  maxlength: _ctx.maxLength,
                  placeholder: btnPlaceholderText.value,
                  showCounter: !item.value.isDisabled,
                  class: _normalizeClass({ 'button-text-input': !isInputFocused.value }),
                  "data-el-name": `${_unref(fieldName)}.${_ctx.index}.locales.${_ctx.indexLang}.caption`,
                  onFocus: _cache[0] || (_cache[0] = ($event: any) => (isInputFocused.value = true)),
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (isInputFocused.value = false)),
                  onInput: handleTextButtonInput
                }, null, 8, ["disabled", "value", "maxlength", "placeholder", "showCounter", "class", "data-el-name"])
              ]),
              _: 1
            }, 8, ["prop"])
          ])
        ]),
        _: 1
      }, 8, ["span"]),
      (!item.value.isDisabled && !isCommon.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "table-row__delete-button",
            onClick: handleDelete
          }, [
            _createVNode(_unref(Close))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})